


















































































































































































































































































import { Guid } from "guid-typescript";
import { cloneDeep, debounce } from "lodash";
import moment from 'moment'
import VueI18n from "vue-i18n";
import { Component, Prop, Vue } from 'vue-property-decorator'

import Icon from "../../../../components/Icon/Icon.vue";
import {
  FileType
} from "../../../../components/NewMessageEditors/NewMessageEditorWithMedia/Media/types";
import { SelectOptionData } from "../../../../components/Pi/types";
import { Product } from "../../../../components/Shop/Products/types";
import PostApi from '../../../../plugins/AdminTemplate/includes/logic/Api/PostApi'
import PostSettingsIcons from "../components/PostSettingsIcons.vue";
import {
  IPostMessage,
  PayedPostMessage,
  PollPost,
  PostType,
  QuizPost,
  Schedule,
  SplitType
} from "../types";
import PaidPostTypePreview from "./components/PaidPostTypePreview.vue";
import PollQuizTypePreview from "./components/PollQuizTypePreview.vue";
import PostInfo from "./components/PostInfo.vue";
import PostTypePreview from "./components/PostTypePreview.vue";
import TelegramPostButtons from './components/TelegramPostButtons.vue'
import TelegramPostPreviewTail from "./components/TelegramPostPreviewTail.vue";
import { MessageAttachments, PostDataStat, PostPreviewRes } from "./types";

@Component({
  name: 'TelegramPostPreview',
  components: {
    PostTypePreview,
    PollQuizTypePreview,
    PaidPostTypePreview,
    TelegramPostPreviewTail,
    Icon,
    TelegramPostButtons,
    PostInfo,
    PostSettingsIcons
  },
  data() {
    return {
      moment,
      FileType,
      PostType
    }
  }
})
export default class TelegramPostPreview extends Vue {
  @Prop() botTitle!: string

  @Prop() targets!: Array<SelectOptionData>

  @Prop() schedule!: Schedule | null

  @Prop() message!: IPostMessage | PollPost | QuizPost | PayedPostMessage

  @Prop() stat!: Array<PostDataStat> | undefined

  @Prop() runTime!: string

  @Prop({ default: null, type: String }) splitType!: SplitType | null

  @Prop({ default: true }) firstCall!:boolean

  @Prop() description!: string | undefined

  @Prop() i18n!: VueI18n

  @Prop() postStyle!: Record<string, any> | undefined

  @Prop() targetToUpload!: string

  @Prop() getPostPreview!: (abortSignal: AbortSignal) => Promise<PostPreviewRes>

  @Prop() products!: Array<Product>

  @Prop({ type: Boolean, required: false, default: false }) isRepeat!: boolean

  @Prop({ type: Boolean, required: false, default: false }) isPostPinned!: boolean

  @Prop({ type: Boolean, required: false, default: false }) isPostWithProtectContent!: boolean

  @Prop({ type: Boolean, required: false, default: false }) isPostWithDisableNotify!: boolean

  @Prop({ type: Boolean, required: false, default: false }) isAd!: boolean

  postInfoModal = false

  currentPost: null | Array<PostDataStat> = null

  overcrowdingPost = false

  debHandler = debounce(this.messageHandler, 3000)

  isLoading = false

  updatedVariant: PostPreviewRes | null = null

  isMessagePreviewType(attachment: MessageAttachments) {
    return attachment.type === FileType.MessagePreview || attachment.type === FileType.TopMessagePreview
  }

  get messagePost() {
    if (!this.overcrowdingPost) {
      if (!this.updatedVariant) {
        return this.message
      } else {
        return this.updatedVariant
      }
    } else {
      return this.mainPost
    }
  }

  get messageText() {
    let resVariants: PostPreviewRes['variants'] | IPostMessage['variants'] | undefined

    if (this.updatedVariant) {
      resVariants = this.updatedVariant?.variants
    } else {
      resVariants = (this.message as IPostMessage)?.variants
    }

    return resVariants?.length ? this.getText(resVariants[0].text) : ''
  }

  get messageButtons() {
    let resVariants: PostPreviewRes['variants'] | IPostMessage['variants'] | undefined

    if (this.updatedVariant) {
      resVariants = this.updatedVariant?.variants
    } else {
      resVariants = (this.message as IPostMessage)?.variants
    }

    return resVariants?.length ? resVariants[0].buttons : []
  }

  get totalCommentCount(): number | null {
    if (this.stat && this.stat.length) {
      return this.stat.reduce((sum, postStat) => sum + postStat.comments_count, 0)
    } else {
      return null
    }
  }

  get totalRepliesCount(): number | null {
    if (this.stat && this.stat.length) {
      return this.stat.reduce((sum, postStat) => sum + postStat.forwards, 0)
    } else {
      return null
    }
  }

  get totalViewsCount(): number | null {
    if (this.stat && this.stat.length) {
      return this.stat.reduce((sum, postStat) => sum + postStat.views, 0)
    } else {
      return null
    }
  }

  get sortedTargets(): null | Array<SelectOptionData> {
    if (this.targets) {
      if (this.targets.length > 10) {
        return this.targets.slice(0, 10)
      } else {
        return this.targets
      }
    } else {
      return null
    }
  }

  checkFileTypeExistsInPostAttachments(type: FileType) {
    if (this.message.type === PostType.Post) {
      const { variants } = this.message

      return this.message && variants?.length > 0 && variants[0]?.attachments?.some(a => a.type === type)
    }

    return false
  }

  get checkReadinessPostPreview(): boolean {
    if (this.overcrowdingPost) {
      return !!(this.mainPost && this.subPost);
    } else {
      return !!this.message;
    }
  }

  messageBySplitType() {
    return this.splitType ? this.message : this.updatedVariant
  }

  existedSplitType() {
    return this.splitType ?? this.updatedVariant!.split_type
  }

  get mainPost() {
    if (this.overcrowdingPost) {
      const message = this.messageBySplitType()
      const messageCopy = cloneDeep(message)

      if (messageCopy && messageCopy.type === PostType.Post) {
        const firstVariant = messageCopy.variants[0]
        const splitType = this.existedSplitType()

        if (splitType === SplitType.LastMedia && firstVariant.attachments) {
          firstVariant.attachments.pop()
        }

        firstVariant.text = ''
        firstVariant.buttons = []

        return messageCopy
      }
    }

    return null
  }

  get subPost() {
    if (this.overcrowdingPost) {
      const message = this.messageBySplitType()
      const messageCopy = cloneDeep(message)

      if (messageCopy && messageCopy.type === PostType.Post) {
        const firstVariant = messageCopy.variants[0]
        const splitType = this.existedSplitType()

        if (splitType === SplitType.LastMedia && firstVariant.attachments) {
          const lastItem = firstVariant.attachments.pop()

          if (lastItem) {
            firstVariant.attachments = [ lastItem ]
          }
        }

        if (splitType === SplitType.Text) {
          firstVariant.attachments = []
        }

        return messageCopy
      }

    }

    return null
  }

  get filePreview(): Partial<Pick<CSSStyleDeclaration, 'backgroundImage'>> {
    const previewLink = (this.message as IPostMessage).variants[0].attachments!.find(this.isMessagePreviewType)?.file

    return {
      backgroundImage: `url(${ PostApi.getRequestUrl('tg', 'getfilepreview') }?file_descriptor=${ previewLink }&target=${ encodeURI(this.targetToUpload) }`
    }
  }

  getText(text: string): string {
    return text.replaceAll('\n', '<br>')
  }

  messageHandler(): void {
    this.checkPostPreview()
  }

  showPostInfo(post: Array<PostDataStat> | undefined): void {
    this.currentPost = post ?? null
    this.postInfoModal = true
  }

  controllers: Record<string, AbortController> = {}

  checkPostPreview(): void {
    this.isLoading = true

    const guid = Guid.create().toString()
    // eslint-disable-next-line compat/compat
    this.$set(this.controllers, guid, new AbortController())

    this.getPostPreview(this.controllers[guid].signal)
      .then((post) => {
        if (post) {
          this.updatedVariant = post

          if ([ SplitType.LastMedia, SplitType.Text ].includes(post.split_type)) {
            this.overcrowdingPost = true
          }
          if (post.split_type === SplitType.None) {
            this.overcrowdingPost = false
          }
        }
      })
      .finally(() => {
        this.$delete(this.controllers, guid)
        this.isLoading = false
      })
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  messageFieldsUnwatch = () => {}
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  styleFieldsUnwatch = () => {}

  beforeDestroy() {
    this.messageFieldsUnwatch()
    this.styleFieldsUnwatch()
    this.debHandler.cancel()

    Object.values(this.controllers).forEach(c => {
      c.abort()
    })
  }

  setWatchers():void {
    this.messageFieldsUnwatch = this.$watch('message.variants', () => {
      this.isLoading = true
      this.debHandler()
    }, {
      deep: true,
      immediate: true
    })

    if (this.postStyle) {
      this.styleFieldsUnwatch = this.$watch('postStyle', () => {
        this.isLoading = true
        this.debHandler()
      }, {
        deep: true,
        immediate: false
      })
    }
  }

  mounted(): void {
    this.$nextTick(() => {

      if (this.firstCall && !this.splitType && this.message.type === PostType.Post) {
        this.setWatchers()
      }

      if (this.splitType) {
        if ([ 'LastMedia', 'Text' ].includes(this.splitType)) {
          this.overcrowdingPost = true
        }
        if (this.splitType === 'None') {
          this.overcrowdingPost = false
        }
      }
    })
  }
}
